export default "__VITE_ASSET__Cb3KTDVg__"